
export default {
  beforeLoad: [app => { // 加载前
  }],
  beforeMount: [app => { // 挂载前
  }],
  afterUnmount: [app => { // 挂载后
  }],
  afterMount: [app => { // 卸载前
  }],
  beforeUnmount: [app => { // 卸载后
  }]
}